// extracted by mini-css-extract-plugin
export default {"select":"priceAdjustment_select__1N6QV","toggle":"priceAdjustment_toggle__cVab9","error":"priceAdjustment_error__GnFnZ"};